import { z } from "zod";

export const ContactSchema = z.object({
  id: z.int().positive().readonly(),
  board: z.int(),
  name: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullable(),
  address: z.string().nullish(),
  notes_text: z.string().nullable(),
  category: z.string().min(1).nullish(),
  status: z.string().min(1).nullish(),
  tag: z.array(z.unknown()).readonly()
});
